import { render, staticRenderFns } from "./StepSelectOtp.vue?vue&type=template&id=1c23cc41&scoped=true"
import script from "./StepSelectOtp.vue?vue&type=script&lang=js"
export * from "./StepSelectOtp.vue?vue&type=script&lang=js"
import style0 from "./StepSelectOtp.vue?vue&type=style&index=0&id=1c23cc41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c23cc41",
  null
  
)

export default component.exports